import { render } from "./PrevBtn.vue?vue&type=template&id=9dd4cc14"
import script from "./PrevBtn.vue?vue&type=script&lang=js"
export * from "./PrevBtn.vue?vue&type=script&lang=js"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__